export const CHANGE_CARD = 'change_card';
export const CHANGE_PLAN = 'change_plan';
export const CANCEL_SUBSCRIPTION = 'cancel_subscription';
export const CREATE_SUBSCRIPTION = 'create_subscription';
export const CREATE_PAYPAL = 'create_paypal';


